import { render, staticRenderFns } from "./creation-site-internet-institut-beaute.vue?vue&type=template&id=16a1275d&"
import script from "./creation-site-internet-institut-beaute.vue?vue&type=script&lang=js&"
export * from "./creation-site-internet-institut-beaute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./creation-site-internet-institut-beaute.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListAdvantage: require('/app/components/ListAdvantage.vue').default})
